import React from 'react';
import { routes } from '../../../utils/helpers/ApiClient';
import { PAGE } from '../../../utils/constants/enums.js';
import { useTranslation } from 'react-i18next';
import Cookies from './Cookies';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <Cookies />
      <footer>
        <div
          style={{ padding: '10px' }}
          className={`text-center lg-p-10 xs-p-5`}
        >
          {t('Portál FRI') + ' '}
          <a href={routes.versionPage} title={`verzia ${PAGE.VERSION}`}>
            verzia {PAGE.VERSION}
          </a>
          , {t('Fakulta riadenia a informatiky')}, Univerzitná 8215/1, 010 26 Žilina <br />
          <a href="https://www.uniza.sk/index.php/univerzita/vseobecne-informacie/ochrana-osobnych-udajov">
            {t('Ochrana osobných údajov na UNIZA')}
          </a>
          <b className="m-md-2">•</b>
          <a className="d-block d-md-inline" href="/stranka/vyhlasenie-o-pristupnosti">
            {t('Vyhlásenie o prístupnosti webového sídla')}
          </a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
